export default __webpack_public_path__ + "static/media/placeholder-large-dark-h.473cccf0.png";